var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('v-icon',{attrs:{"small":""}},[_vm._v("\n    "+_vm._s(_vm.difficultyAppreciationIcon())+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }